var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-layout",
        {
          attrs: { "align-center": "", "justify-center": "", "fill-height": "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs12: "", sm8: "", md5: "" } },
            [
              _c(
                "v-card",
                { staticClass: "elevation-12" },
                [
                  _c(
                    "v-toolbar",
                    { attrs: { dark: "", color: "primary" } },
                    [
                      _c("v-toolbar-title", [_vm._v("Login")]),
                      _vm._v(" "),
                      _c("v-spacer")
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    [
                      _c("img", {
                        attrs: {
                          src: require("../../static/img/doe-logo.png"),
                          alt: ""
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "v-form",
                        [
                          _c("v-text-field", {
                            attrs: {
                              "prepend-icon": "person",
                              name: "login",
                              label: "Username",
                              "error-messages": _vm.usernameErrors,
                              autocomplete: "off",
                              type: "text"
                            },
                            on: {
                              blur: _vm.$v.username.$touch,
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onLoginClick($event)
                              }
                            },
                            model: {
                              value: _vm.username,
                              callback: function($$v) {
                                _vm.username =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "username"
                            }
                          }),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: {
                              "prepend-icon": "lock",
                              name: "password",
                              label: "Password",
                              "error-messages": _vm.passwordErrors,
                              autocomplete: "off",
                              type: "password"
                            },
                            on: {
                              blur: _vm.$v.password.$touch,
                              keyup: function($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.onLoginClick($event)
                              }
                            },
                            model: {
                              value: _vm.password,
                              callback: function($$v) {
                                _vm.password =
                                  typeof $$v === "string" ? $$v.trim() : $$v
                              },
                              expression: "password"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-alert",
                            { attrs: { value: _vm.errorMsg, type: "error" } },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.errorMsg) +
                                  "\n              "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-card-actions",
                            [
                              _c("v-spacer"),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    disabled: _vm.loading || _vm.$v.$invalid,
                                    color: "primary"
                                  },
                                  on: {
                                    click: function($event) {
                                      $event.preventDefault()
                                      return _vm.onLoginClick($event)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                  Login\n                "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.loading ? _c("div", [_c("loading-component")], 1) : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d9df09", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d9df09","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = null
// module chunks = 